
import {
  CHANNEL_ADDED,
  CHANNEL_DIS_INTEGRATED
} from "@/constants/MixpanelEvents.js";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import DisintergrationReasonDialog from "../dialogs/disintergration-reason-dialog.vue";
import InfoDialogMobile from "../dialogs/info-dialog-mobile.vue";
import PairChannelDialog from "../dialogs/pair-channel-dialog.vue";
import WhatsappIntegrationDialog from "../dialogs/whatsapp-integration-dialog.vue";
import ChannelManagerForm from "./channel-manager-form.vue";
import PointOfContactDialog from "../dialogs/point-of-contact-dialog.vue";

export default {
  components: {
    DisintergrationReasonDialog,
    PairChannelDialog,
    WhatsappIntegrationDialog,
    ChannelManagerForm,
    InfoDialogMobile,
    PointOfContactDialog
  },
  props: {
    selectedChannel: {
      type: Object,
      default: {}
    },
    addModifyDialog: {
      type: Boolean,
      default: false
    },
    selectedChannelCategory: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      channelsList: [],
      channelInfoForIntegration: [],
      loading: false,
      showUnpairChannelConfirmationDialog: false,
      showDisIntegrationReasonDialog: false,
      showPairChannelDialog: false,
      showChannelUnpairDetailsDialog: false,
      unpairChannel: {},
      isUnpairForChannel: false,
      infoText: "",
      infoTitle: "",
      showInfoDialog: false,
      showWhatsappIntegrationDialog: false,
      whatsappIntegrationBrandInfo: "",
      whatsappInfo: new Map(),
      selectedBrandId: "",
      selectedPlatform: "",
      channelInfoForEdit: {},
      showPointOfContactDialog: false
    };
  },
  beforeMount() {
    this.getRestaurantChannels();
    this.populateChannelsList();
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    ...mapGetters("restaurant", [
      "hasMultipleBrands",
      "getLocationChannels",
      "getAllBrands"
    ]),
    ...mapState("auth", ["user"]),
    isPairedChannelTab() {
      return this.selectedChannelCategory === "paired";
    }
  },
  watch: {
    selectedChannelCategory() {
      this.populateChannelsList();
    }
  },
  methods: {
    ...mapActions("restaurant", [
      "getLocationDetails",
      "postRestaurantFeedback",
      "getRestaurantChannels",
      "integrateChannels",
      "disintegrateChannels"
    ]),
    ...mapActions("menu", ["uploadImage"]),
    populateChannelsList() {
      this.channelsList = this.isPairedChannelTab
        ? JSON.parse(JSON.stringify(this.getAllBrands))
        : this.getUnpairedBrandsList();

      if (this.hasMultipleBrands) {
        this.channelsList.forEach((brand) => {
          brand.restaurant_platforms = brand.restaurant_platforms.filter(
            (platform) =>
              platform.platform_name !==
                this.$constants.Channels.WHATSAPP.name &&
              platform.name !== this.$constants.Channels.WHATSAPP.name
          );
        });
      }

      // this.validateForm();
    },
    getUnpairedBrandsList() {
      let unpairedBrands = [];
      for (let index = 0, n = this.getAllBrands.length; index < n; index++) {
        unpairedBrands.push(
          JSON.parse(JSON.stringify(this.getAllBrands[index]))
        );

        const element = this.getAllBrands[index];

        const list = $nuxt.$constants.Channels.CHANNELS.filter((channel) => {
          return !element.restaurant_platforms.some((linkedChannel) => {
            return channel.name == linkedChannel.platform_name;
          });
        });
        unpairedBrands[index].restaurant_platforms = JSON.parse(
          JSON.stringify(list)
        );
      }
      return unpairedBrands;
    },
    handleChannelDetailsSubmission() {
      if (this.hasMultipleBrands) {
        this.handleIntegration();
      } else {
        this.showPointOfContactDialog = true;
      }
    },

    async handleIntegration(pointOfContacts = []) {
      this.showPointOfContactDialog = false;
      this.loading = true;
      let platforms = [];
      for (const restaurant of this.channelsList) {
        let chosenChannels = restaurant.restaurant_platforms.filter(
          (channel) => !!channel.userInput
        );
        for (let channel of chosenChannels) {
          if (channel.userInput.imgObj?.name) {
            try {
              let formData = new FormData();
              formData.append("item_image", channel.userInput.imgObj);
              const { data } = await this.uploadImage(formData);
              if (data.status === "success") {
                channel.userInput.restaurant_logo = data?.data;
                delete channel.userInput.imgObj;
              } else {
                this.$nuxt.$emit("show-error-toast", data.message);
              }
            } catch (error) {
              console.error(error);
            }
          } else {
            const firstLetter = this.user?.name?.charAt(0)?.toLowerCase();
            channel.userInput.restaurant_logo = `https://res.cloudinary.com/vyooha/image/upload/v1704528871/${firstLetter}.png`;
            delete channel.userInput.imgObj;
          }
          platforms.push({
            ...channel.userInput,
            point_of_contacts: pointOfContacts
          });
        }
      }
      try {
        await this.integrateChannels({
          payload: { restaurant_platforms: platforms }
        });
        this.integrationRequested();
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.loading = false;
    },

    async handleDisintegrateChannels(reason) {
      this.loading = true;
      try {
        let payload = { restaurant_platforms: [], reason };
        this.channelsList.forEach((restaurant) => {
          restaurant.restaurant_platforms.forEach((channel) => {
            if (channel.isSelected) {
              payload.restaurant_platforms.push({
                id: channel.id
              });
            }
          });
        });
        await this.disintegrateChannels({ payload });
        this.showDisIntegrationReasonDialog = false;
        this.disintegrationRequested();
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.loading = false;
    },

    channelUpdatePostAction() {
      this.getLocationDetails();
      this.$nuxt.$emit("switch-restaurant");
    },
    integrationRequested() {
      this.mixPanelTrackEvent(CHANNEL_ADDED);
      this.channelUpdatePostAction();
      this.infoText =
        "Your integration request has been to send to onboarding team. We will let you know once the integration process is completed";
      this.infoTitle = "Integration Request Send";
      this.showInfoDialog = true;
    },
    disintegrationRequested() {
      this.mixPanelTrackEvent(CHANNEL_DIS_INTEGRATED);
      this.channelUpdatePostAction();
      this.infoText =
        "The dis-integration request has been forwarded to our onboarding team. We will inform you as soon as the dis-integration process is completed.";
      this.infoTitle = "Dis-integration Request Send";
      this.showInfoDialog = true;
    },
    openWhatsappIntegrationDialog(e) {
      this.showWhatsappIntegrationDialog = true;
      this.selectedBrandId = e.brandId;
    },
    onWhatsappDialogClose(e) {
      this.showWhatsappIntegrationDialog = false;
      this.handleChannelInfosForIntegration(e);
    },

    openPairingDialog(e) {
      this.selectedBrandId = e.brandId;
      this.selectedPlatform = this.getChannelConstObjById(e.channelId);
      if (
        this.selectedPlatform.name === this.$constants.Channels.WHATSAPP.name
      ) {
        this.openWhatsappIntegrationDialog(e);
      } else {
        this.showPairChannelDialog = true;
      }
    },
    handleDisintegrationSelection(e, channelIndex, brandIndex) {
      this.channelsList[brandIndex].restaurant_platforms[
        channelIndex
      ].isSelected =
        !this.channelsList[brandIndex].restaurant_platforms[channelIndex]
          .isSelected;
      this.channelsList = JSON.parse(JSON.stringify(this.channelsList));
    },
    handleChannelSubmission(e) {
      this.showPairChannelDialog = false;
      this.handleChannelInfosForIntegration(e);
      console.log(this.channelInfoForIntegration);
    },
    handleChannelInfosForIntegration(channelInfo) {
      if (!channelInfo) {
        return;
      }
      this.channelsList.forEach((restaurant) => {
        if (restaurant.id === this.selectedBrandId) {
          restaurant.restaurant_platforms.forEach((channel) => {
            if (channel.id === this.selectedPlatform.id) {
              channel["userInput"] = { ...channelInfo };
            }
          });
        }
      });

      this.channelsList = this.channelsList.slice(0);
    },
    deleteChannelInfo(e) {
      this.channelsList.forEach((restaurant) => {
        if (restaurant.id === e.brandId) {
          restaurant.restaurant_platforms.forEach((channel) => {
            if (channel.id === e.channelId) {
              delete channel["userInput"];
            }
          });
        }
      });
      this.channelsList = this.channelsList.slice(0);
    }
  }
};
